/*
 * @Author: YuanYuan
 * @Date: 2024-02-04 19:44:23
 * @LastEditTime: 2026-06-18 16:03:41
 * @Description: vuex 状态管理
 */
import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex)

const modules = {}
const context = require.context('./', true, /^\.\/(?!index).*?\.js$/)

context.keys().forEach(key => {
  const name = key.replace(/\.\/(.*)?\.js/, (str, $1) => $1)
  modules[name] = context(key).default
})

const storeConfig = {
  modules: {
    ...modules
  }
}

const plugins =  [
  createPersistedState({
    key: 'csec-1.0.2',
    expires: 10 * 60 * 1000
  })
]

/*if (process.env.VUE_APP_STORE_FIRED !== 'true') {
  console.log('启用 vuex 持久化存储')
  storeConfig.plugins = plugins
}*/
storeConfig.plugins = plugins

const store = new Vuex.Store(storeConfig)

export default store
